import { User } from "../gateway/User/User";

export class SaveManyUserUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ accountingId = "", users = [] } = {}) {
        const payload = this.sanitizeInput({ accountingId, users });
        if (!payload.accountingId || !payload.users.length) return [];
        const response = await this.UserGateway.saveMany(
            payload.accountingId,
            payload.users
        );
        return response;
    }

    sanitizeInput({ accountingId = "", users = [] } = {}) {
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedUsers = Array.isArray(users)
            ? users.filter((user) => user && typeof user === "object")
            : [];
        return {
            accountingId: sanitizedAccountingId,
            users: sanitizedUsers
        };
    }
}
